import React from "react";
import "./TopFaq.css"

class TopFaq extends React.Component {
    constructor(props) {
        /* We MUST call the parent class contructor and send it the props object */
        super(props);

        // Setting the initial state of the NormalForms component
        this.state =
            {
                contents: this.props.value
            };


    } // End of constructor()


    onTopClick = (event) => {
        this.tippyTop.scrollIntoView();
    }

    oneClick = (event) => {
        console.log("First was clicked.");
        this.one.scrollIntoView();
    }

    twoClick = (event) => {
        console.log("Second was clicked.");
        this.two.scrollIntoView();
    }

    threeClick = (event) => {
        console.log("Third was clicked.");
        this.three.scrollIntoView();
    }

    fourClick = (event) => {
        console.log("First was clicked.");
        this.four.scrollIntoView();
    }

    fiveClick = (event) => {
        console.log("First was clicked.");
        this.five.scrollIntoView();
    }

    sixClick = (event) => {
        console.log("First was clicked.");
        this.six.scrollIntoView();
    }

    sevenClick = (event) => {
        console.log("First was clicked.");
        this.seven.scrollIntoView();
    }

    eightClick = (event) => {
        console.log("First was clicked.");
        this.eight.scrollIntoView();
    }

    nineClick = (event) => {
        console.log("First was clicked.");
        this.nine.scrollIntoView();
    }

    tenClick = (event) => {
        console.log("First was clicked.");
        this.ten.scrollIntoView();
    }

    elevenClick = (event) => {
        console.log("First was clicked.");
        this.eleven.scrollIntoView();
    }

    twelveClick = (event) => {
        console.log("First was clicked.");
        this.twelve.scrollIntoView();
    }

    thirteenClick = (event) => {
        console.log("First was clicked.");
        this.thirteen.scrollIntoView();
    }



    render() {
        return (

            <div className='TopFaqMain'>
            
                <h3 ref={node => this.tippyTop = node}>Frequently Asked Questions</h3>

                <p onClick={this.oneClick} className=" question q-one faq-text-click">What are your salary requirements?</p>
                <p onClick={this.twoClick} className=" question q-two faq-text-click">Why did you leave your last company?</p>
                <p onClick={this.threeClick} className=" question q-three faq-text-click">How soon can you start?</p>
                <p onClick={this.fourClick} className=" question q-four faq-text-click">Will you require sponsorship at any point in time?</p>
                <p onClick={this.fiveClick} className=" question q-five faq-text-click">How much experience do you have in Java?</p>
                <p onClick={this.sixClick} className=" question q-six faq-text-click">How much experience do you have in Object Oriented Programming?</p>
                <p onClick={this.sevenClick} className=" question q-seven faq-text-click">How much experience do you have in C?</p>
                <p onClick={this.eightClick} className=" question q-eight faq-text-click">How much experience do you have in C++?</p>
                <p onClick={this.nineClick} className=" question q-nine faq-text-click">How much experience do you have in JavaScript?</p>
                <p onClick={this.tenClick} className=" question q-ten faq-text-click">How much experience do you have in HTML?</p>
                <p onClick={this.elevenClick} className=" question q-eleven faq-text-click">How much experience do you have in CSS?</p>
                <p onClick={this.thirteenClick} className=" question q-thirteen faq-text-click">How much experience do you have working with automated unit test technologies?</p>

                <hr />

            <div className="FaqFollowing">
                <div className="body-div">
                    <p ref={node => this.one = node} className=" body-question q-one">What are your salary requirements?</p>
                    <p>I don't want a company to pay me more than they would pay a person with knowledge and skills comparable to mine.
                    If they do, I will be the first target for subsequent layoffs, and I like stability in my
                    career.</p>
                    <p>I also expect a salary that is fair to both me and my employer.  I do answer the phone when recruiters and colleagues call.
                        If I'm offered a position that pays twenty or twenty-five percent higher than my present salary for comparable work,
                        I will go and work for the company offering more money.  That means that trying to "low ball" me and paying me
                        less than I am worth is not fair for me or the company making the offer because that company will have invested
                    money for training me in their procedures only to have me leave.<button onClick={this.onTopClick}>&#x021D1;</button></p>

                </div>

                <div className="body-div">
                    <p ref={node => this.two = node} className=" body-question q-two">Why did you leave your last company?</p>
                    <p>I didn't leave my last company; they left me.  Six weeks after I began working at Linq3, a start up company,
                        the investors announced they were shutting down the company and selling off the company's assets.  I continued at
                        Linq3 for the following three months to help facilitate an orderly shutdown of the company.
                         <button onClick={this.onTopClick}>&#x021D1;</button></p>

                </div>

                <div className="body-div">
                    <p ref={node => this.three = node} className=" body-question q-three">How soon can you start?</p>
                    <p>Immediately <button onClick={this.onTopClick}>&#x021D1;</button></p>

                </div>


                <div className="body-div">
                    <p ref={node => this.four = node} className=" body-question q-four">Will you require sponsorship at any point in time?</p>
                    <p>No <button onClick={this.onTopClick}>&#x021D1;</button></p>

                </div>

                <div className="body-div">
                    <p ref={node => this.five = node} className=" body-question q-five">How much experience do you have in Java?</p>
                    <p>One year - When I was a graduate assistant at Clemson, I taught the freshman computer science Java labs.  Later
                    in my career, I was loaned to a Java group for three months because the group was behind
                    schedule. <button onClick={this.onTopClick}>&#x021D1;</button></p>

                </div>

                <div className="body-div">
                    <p ref={node => this.six = node} className=" body-question q-six">How much experience do you have in Object
                    Oriented Programming?</p>
                    <p>Thirteen years.  My studies at Clemson for my Master's Degree in Computer Science focused on object
                        oriented programming, and
                    I continued with this focus while I was working at Motorola.</p>
                    <p>Yongjun Geng, a colleague of mine at Motorola wrote: "I was always amazed at Charles's deep knowledge
                        and skills in C++ and Object
                        Oriented Design. He was the expert and the go-to person for me and other engineers for questions
                        in C++ and OO design."  <button onClick={this.onTopClick}>&#x021D1;</button></p>
                </div>

                 <div className="body-div">
                <p ref={node => this.seven = node} className=" body-question q-seven">How much experience do you have in C?</p>
                <p>Sixteen years.  Both Motorola and EchoStar had development done primarily in 
                    C. All of the debugging I did of other people's code was 
                    debugging C code.<button onClick={this.onTopClick}>&#x021D1;</button></p>
                </div>

                <div className="body-div">
                <p ref={node => this.eight = node} className=" body-question q-eight">How much experience do you have in C++?</p>
                <p>Thirteen years.  My studies at Clemson for my Master's Degree in Computer Science focused on object
                        oriented programming in C++, and
                    I continued with this focus while I was working at Motorola.</p>
                    <p>Yongjun Geng, a colleague of mine at Motorola wrote: "I was always amazed at Charles's deep knowledge
                        and skills in C++ and Object
                        Oriented Design. He was the expert and the go-to person for me and other engineers for questions
                        in C++ and OO design."  <button onClick={this.onTopClick}>&#x021D1;</button></p>
                </div>

                <div className="body-div">
                <p ref={node => this.nine = node} className=" body-question q-nine">How much experience do you have in JavaScript?</p>
                <p>I attended a seven month Georgia Tech Professional Education course in Full Stack Web Development that was VERY intensive. 
                    I believe the most truthful answer to this question is one year's experience.  We began writing JavaScript 
                    code almost from day one and continued throughout the course. <button onClick={this.onTopClick}>&#x021D1;</button></p>
                </div>

                <div className="body-div">
                <p ref={node => this.ten = node} className=" body-question q-ten">How much experience do you have in HTML?</p>
                <p>I attended a seven month Georgia Tech Professional Education course in Full Stack Web Development that 
                    was VERY intensive. I believe the most truthful answer to this question is 
                    one year's experience. <button onClick={this.onTopClick}>&#x021D1;</button></p>
                </div>

                <div className="body-div">
                <p ref={node => this.eleven = node} className=" body-question q-eleven">How much experience do you have in CSS?</p>
                <p>I attended a seven month Georgia Tech Professional Education course in Full Stack Web Development that 
                    was VERY intensive. I believe the most truthful answer to this question is 
                    one year's experience. <button onClick={this.onTopClick}>&#x021D1;</button></p>
                </div>

                <div className="body-div">
                <p ref={node => this.thirteen = node} className=" body-question q-thirteen">How much experience do you have 
                working with automated unit test technologies?</p>
                <p> I have about three months in graduate school at Clemson using a tool called dejaGnu 
                    for automated unit testing.  <button onClick={this.onTopClick}>&#x021D1;</button></p>
                </div>

</div>

            </div>
            



        )

    }

}

export default TopFaq;



// WEBPACK FOOTER //
// ./src/components/Resume/TopFaq.js